import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { ApolloProvider } from '@apollo/client';
import { client } from '@services/graphql';
import { AuthProvider } from '@contexts/auth-context';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';
import { isSentryEnabled } from '@services/error-reporting';

Sentry.init({
  // Enabled only for production builds (NODE_ENV=production).
  dsn: isSentryEnabled()
    ? 'https://2fe41bdf5f399d2ef7bd1563318d67a6@o4506140147449856.ingest.us.sentry.io/4509004652609536'
    : undefined,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: 'light',
    }),
  ],

  environment: import.meta.env.ENV,
  // TODO: Update tracePropagationTargets as need after release
  tracePropagationTargets: ['localhost', /^https?:\/\/voylogic-stage.s3\.s3-website\.us-east-2\.amazonaws\.com/],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: import.meta.env.ENV === 'production' ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  initialScope: {
    tags: {
      build: `${import.meta.env.COMMIT_HASH}`,
    },
  },
});

const postHogOptions = {
  api_host: import.meta.env.POSTHOG_HOST,
  disabled: ['local-dev', 'development'].includes(import.meta.env.ENV),
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider apiKey={import.meta.env.POSTHOG_KEY} options={postHogOptions}>
      <AuthProvider>
        <ApolloProvider client={client}>
          <App />
        </ApolloProvider>
      </AuthProvider>
    </PostHogProvider>
  </React.StrictMode>
);
